import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BlogCard } from "@/components/BlogCard";
import { ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${API}/blog`);
        setPosts(response.data);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const featuredPost = posts.find((post) => post.is_featured);
  const otherPosts = posts.filter((post) => !post.is_featured || post !== featuredPost);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-deep-moss font-serif text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      {/* Breadcrumb */}
      <div className="bg-white border-b border-stone-200">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl py-4">
          <nav className="flex items-center gap-2 text-sm font-sans" data-testid="breadcrumb">
            <Link to="/" className="text-stone-500 hover:text-deep-moss">
              Home
            </Link>
            <ChevronRight className="w-4 h-4 text-stone-400" />
            <span className="text-stone-900">Blog</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="font-accent text-xs text-stone-500 uppercase tracking-widest mb-2">
            From Our Store
          </p>
          <h1 className="font-serif text-4xl md:text-5xl font-semibold text-stone-900 mb-4">
            Store Blog
          </h1>
          <p className="font-sans text-stone-600 max-w-xl mx-auto">
            Discover what's new in our store, learn about our products, and get tips for your plants and wellness journey.
          </p>
        </div>

        {/* Featured Post */}
        {featuredPost && (
          <div className="mb-16">
            <BlogCard post={featuredPost} featured={true} />
          </div>
        )}

        {/* Other Posts */}
        {otherPosts.length > 0 && (
          <div>
            <h2 className="font-serif text-2xl font-semibold text-stone-900 mb-8">
              More Posts
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {otherPosts.map((post) => (
                <BlogCard key={post.id} post={post} />
              ))}
            </div>
          </div>
        )}

        {posts.length === 0 && (
          <div className="text-center py-16">
            <p className="font-sans text-stone-600">No blog posts yet. Check back soon!</p>
          </div>
        )}
      </div>
    </div>
  );
};
